export default __webpack_public_path__ + "static/media/share-button.3e8e51f3.svg";